<template>
  <a-modal
    :visible="visible"
    title="编辑详细描述"
    :maskClosable="false"
    :destroyOnClose="true"
    width="800px"
    @cancel="close"
  >
    <editor v-model="innerContent" :height="400" />
    <template slot="footer">
      <a-button @click="close">取消</a-button>
      <a-button type="primary" :loading="loading" @click="handleOk"> 保存 </a-button>
    </template>
  </a-modal>
</template>

<script>
import Editor from '@/components/Editor/Editor.vue'
export default {
  name: 'SkuContentEditor',
  components: { Editor },
  data() {
    return {
      visible: false,
      loading: false,
      innerContent: '',
    }
  },
  methods: {
    /* 供父级调用的唯一入口 */
    open(html = '') {
      this.innerContent = html
      this.visible = true
    },

    /* 供父级调用的关闭入口 */
    close() {
      this.visible = false
      this.$emit('cancel')
    },

    /* 内部保存 */
    handleOk() {
      this.loading = true
      this.$emit('confirm', this.innerContent, () => {
        // 父级完成逻辑后再关闭（支持异步）
        this.visible = false
        this.loading = false
      })
    },
  },
}
</script>
